<template>
    <div :id="line" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="gridSystemModalLabel">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <!--<div class="modal-header">
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                  <h4 class="modal-title">Comprovante de cancelamento</h4>
                </div> -->
                <div class="modal-body">
                    <header class="site-header-3 site-header" style="border-top: 5px solid #29b6f6;">
                        <!-- Main bar start -->
                        <div id="sticked-menu" class="main-bar">
                            <div class="">                
                                <div class="row">                    
                                    <div class="col-md-12">
                                        <!-- logo begin -->
                                        <div id="logo" class="site-logo">                            
                                            <a :href="dadosconteudo.linklogo">
                                                <img :src="dadosconteudo.imglogo" alt="" class="logo logo-principal">
                                                <div class="nomes-logo">
                                                    <span>{{ dadosconteudo.tipoentidade}}</span>
                                                    <h1>{{dadosconteudo.nomeentidade}}</h1>
                                                </div>
                                            </a>
                                        </div>
                                        <!-- logo close -->
                                        <div class="title-system pull-right" style="">
                                            <p class="title-ouvi">{{dadosconteudo.nomesistema}}</p>                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </header>
                    <Br>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="portlet-body">
                                <div class="table-scrollable">
                                    <table class="table">
                                        <tbody>
                                            <tr>
                                                <td class="titulotable" width="19%" align="right" style="background-color: #eee;"> Data de Publicação </td>
                                                <td class="conteudotable">
                                                    {{dadosconteudo.datapublicao}}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="titulotable" align="right" style="background-color: #eee;"> Data do Lançamento </td>
                                                <td class="conteudotable">
                                                    {{dadosconteudo.datalancamento}}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="titulotable" align="right" style="background-color: #eee;"> Entidade </td>
                                                <td class="conteudotable">
                                                    {{dadosconteudo.entidade}}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="titulotable" align="right" style="background-color: #eee;"> Nº Proc. Adm </td>
                                                <td class="conteudotable">
                                                    {{dadosconteudo.procadm}}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="titulotable" align="right" style="background-color: #eee;"> Valor </td>
                                                <td class="conteudotable">
                                                    R$ {{dadosconteudo.valor}}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="titulotable" align="right" style="background-color: #eee;"> Fase </td>
                                                <td class="conteudotable">
                                                    {{dadosconteudo.fase}}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="titulotable" align="right" style="background-color: #eee;"> Credor </td>
                                                <td class="conteudotable">
                                                    {{dadosconteudo.credor}}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="titulotable" align="right" style="background-color: #eee;"> CPF/CNPJ </td>
                                                <td class="conteudotable">
                                                    {{dadosconteudo.cpfcnpj}}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="titulotable" align="right" style="background-color: #eee;"> Natureza </td>
                                                <td class="conteudotable">
                                                    {{dadosconteudo.natureza}}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="titulotable" align="right" style="background-color: #eee;"> Função </td>
                                                <td class="conteudotable">
                                                    {{dadosconteudo.funcao}}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="titulotable" align="right" style="background-color: #eee;"> Sub-Função </td>
                                                <td class="conteudotable">
                                                    {{dadosconteudo.subfuncao}}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="titulotable" align="right" style="background-color: #eee;"> Bem/Serviço Prestado </td>
                                                <td class="conteudotable">
                                                    {{dadosconteudo.servprestado}}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                </div><!-- FInal do modalbody-->
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal">Fechar</button>
                </div>
            </div><!-- /.modal-content -->
        </div><!-- /.modal-dialog -->
    </div><!-- /.modal -->
</template>
<script>
export default {
  data() {
    return {
      dadosconteudo: {},
      imglogo: "./src/assets/images/logo.png",
    };
  },
  methods: {},
  ready() {
    $.ajaxSetup({
      async: false,
    });

    var self = this;

    var urlAtual = window.location.href.split("/");
    var covid = false;

    for (var c = 0; c < urlAtual.length; c++) {
      if (urlAtual[c] == "covid") {
        covid = true;
      }
    }

    $("#" + self.line).on("show.bs.modal", function (e) {
      $.getJSON(
        "./server/despesa.php",
        { id: self.line, covid: covid },
        function (links) {
          self.dadosconteudo = links[0];
          //console.log(self.dadosconteudo)
        }
      );
    });

    $.ajaxSetup({
      async: true,
    });
  },
  props: {
    line: {},
  },
};
</script>
<style scoped>
.table-scrollable {
  max-height: 383px;
  overflow-y: auto;
}
</style>


// WEBPACK FOOTER //
// infomodal.vue?65ff1d50